import api from "./api";

export interface Video {
  cart_items: any;
  videos: any;
  video: any;
  id: string;
  court_id: string;
  storage_url: string;
  watermarked_url: string;
  watch_count: number;
  price: number;
  purchase_count: boolean;
  download_count: number;
  created_at: string;
  updated_at: string;
  // Used for user library
  user_id: string;
  clip_id: string;
  bought: string;
  merchant_name: string;
  merchant_address: string;
  court_name: string;
  court_location: string;
  // Add other Video properties as needed
}

export const videoService = {
  // Fetch all Videos
  async fetchVideo(): Promise<Video[]> {
    const response = await api.get<Video[]>("/clips");
    return response.data;
  },
  // Fetch  Videos by court ID
  async fetchVideosByCourtId(
    courtID: string,
    dateFrom: string,
    dateTo: string,
    page?: number,
    limit?: number
  ): Promise<any> {
    const params: any = {
      dateFrom: dateFrom + " 00:00:00",
      dateTo: dateTo + " 23:59:59",
    };
    if (page !== undefined) params.page = page;
    if (limit !== undefined) params.limit = limit;

    const response = await api.get(`/clips/court/${courtID}`, {
      params,
    });
    // The API currently returns an object containing clips and pagination info
    return response.data;
  },
  //fetch videos by id
  async fetchVideoById(videoID: string): Promise<Video> {
    const user_id = JSON.parse(localStorage.getItem("user"))?.id;
    const response = await api.get<Video>(`/clips/${videoID}/${user_id}`);
    return response.data;
  },
  //fetch users videos
  async fetchUsersVideoLibrary(): Promise<Video> {
    const user_id = JSON.parse(localStorage.getItem("user"))?.id;
    const response = await api.get<Video>(`/clips/user_library/${user_id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  },
};
